var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8154_38322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.76221 20.9688V19.9688C1.76221 16.1028 4.89621 12.9688 8.76221 12.9688V12.9688C12.6282 12.9688 15.7622 16.1028 15.7622 19.9688V20.9688",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76221 12.9688C10.9713 12.9688 12.7622 11.1779 12.7622 8.96875C12.7622 6.75961 10.9713 4.96875 8.76221 4.96875C6.55307 4.96875 4.76221 6.75961 4.76221 8.96875C4.76221 11.1779 6.55307 12.9688 8.76221 12.9688Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0594 10.0855C14.9717 10.845 14.9732 11.5577 15.002 12.1163C15.0383 12.817 15.5806 13.3594 16.2814 13.3956C16.84 13.4245 17.5527 13.426 18.3122 13.3383M15.0594 10.0855C15.2136 8.74917 15.6437 7.26788 16.6858 6.22582C17.7278 5.18376 19.2091 4.75364 20.5454 4.59941M15.0594 10.0855L18.3122 13.3383M18.3122 13.3383C19.6485 13.1841 21.1298 12.754 22.1719 11.7119C23.2139 10.6698 23.644 9.18855 23.7983 7.85224M20.5454 4.59941C21.305 4.51175 22.0177 4.51321 22.5763 4.54208C23.277 4.5783 23.8194 5.12069 23.8556 5.82141C23.8845 6.38001 23.8859 7.09271 23.7983 7.85224M20.5454 4.59941L23.7983 7.85224M17.8614 10.5363L18.6451 9.75258M18.6451 9.75258L17.8614 8.96886M18.6451 9.75258L19.4288 10.5363M18.6451 9.75258L20.2125 8.18513M20.2125 8.18513L20.9963 7.40141M20.2125 8.18513L19.4288 7.40141M20.2125 8.18513L20.9963 8.96886",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8154_38322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.762207 0.96875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupwhite);
export default __webpack_public_path__ + "static/media/groupwhite.86fcd21a85c7c6062c5a9c237a83dea2.svg";
export { ForwardRef as ReactComponent };